/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { APP_INITIALIZER, Provider } from '@angular/core';
import { OidcService } from './oidc.service';

/**
 * Boot-time sanitisation of `sessionStorage.oidc_return_url`. Catches values that were
 * poisoned before this fix shipped (mid-session from B1/B2/B5 in pre-fix builds) so
 * users mid-loop self-heal on the first page load after deploy. Wrapped in try/catch —
 * the migration must never block app boot.
 */
export const oidcReturnUrlMigrationProvider: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  deps: [OidcService],
  useFactory: (oidc: OidcService) => () => {
    try {
      oidc.sanitizeStoredReturnUrl();
    } catch {
      // boot must never block on this
    }
  },
};
